import initModals from './blade-components/modal';
initModals();

import NP_TM from './components/np-tagmanager';
window.tag = new NP_TM({
	additionalEvents: {
		// Einkommensschutz
		incomeProtection_unemplyoment:	{ event: 'einkommensschutz_antrag_arbeitslosigkeit' },
		incomeProtection_disability:	{ event: 'einkommensschutz_antrag_arbeitsunfaehigkeit' },
		backToSelection_Einkommensschutz: { event: 'einkommensschutz_btn_zurueck_uebersicht' },


		// Ikano Shopping Card
		shoppingCard_unemplyoment: { event: 'ikea_shopping_card_antrag_arbeitslosigkeit' },
		shoppingCard_disability: { event: 'ikea_shopping_card_antrag_arbeitsunfaehigkeit' },
		shoppingCard_fatality: { event: 'ikea_shopping_card_antrag_todesfall' },
		backToSelection_Ikano_Shopping_Card: { event: 'ikea_shopping_card_btn_zurueck_uebersicht' },


		// IKEA Family Bezahlkarte
		familyCard_fatality: { event: 'ikea_family_bezahlkarte_antrag_todesfall' },
		familyCard_disability: { event: 'ikea_family_bezahlkarte_antrag_arbeitsunfaehigkeit' },
		familyCard_arbeitslosigkeit: { event: 'ikea_family_bezahlkarte_antrag_arbeitslosigkeit' },
		backToSelection_IKEA_Family_Bezahlkarte: { event: 'ikea_family_bezahlkarte_btn_zurueck_uebersicht' },


		// IKEA Finanzierung
		ikeaFinance_unemployment: { event: 'ikea_finzanierung_antrag_arbeitslosigkeit' },
		ikeaFinance_disability: { event: 'ikea_finzanierung_antrag_arbeitsunfaehigkeit' },
		ikeaFinance_fatality: { event: 'ikea_finzanierung_antrag_todesfall' },
		backToSelection_IKEA_Finanzierung: { event: 'ikea_finzanierung_btn_zurueck_uebersicht' },


		// IKEA Kreditkarte
		ikeaCreditCard_unemplyoment: { event: 'ikea_kreditkarte_antrag_arbeitslosigkeit' },
		ikeaCreditCard_disability: { event: 'ikea_kreditkarte_antrag_arbeitsunfaehigkeit' },
		ikeaCreditCard_fatality: { event: 'ikea_kreditkarte_antrag_todesfall' },
		ikeaCreditCard_illness: { event: 'ikea_kreditkarte_antrag_schwere_krankheit' },
		ikeaCreditCard_aloAssistance: { event: 'ikea_kreditkarte_antrag_alo_assistance' },
		ikeaCreditCard_auAssistance: { event: 'ikea_kreditkarte_antrag_au_assistance' },
		ikeaCreditCard_shopping: { event: 'ikea_kreditkarte_antrag_einkaufs_versicherung' },
		ikeaCreditCard_repair: { event: 'ikea_kreditkarte_antrag_reparatur_versicherung' },
		ikeaCreditCard_ticket: { event: 'ikea_kreditkarte_antrag_ticket_versicherung' },
		ikeaCreditCard_bestPrice: { event: 'ikea_kreditkarte_antrag_best_preis_versicherung' },
		ikeaCreditCard_travel: { event: 'ikea_kreditkarte_antrag_reise_versicherung' },
		ikeaCreditCard_atmRobbery: { event: 'ikea_kreditkarte_antrag_geldautomatenraub' },
		ikeaCreditCard_creditcard_fraud: { event: 'ikea_kreditkarte_antrag_kreditkarten_missbrauch' },
		ikeaCreditCard_pishing: { event: 'ikea_kreditkarte_antrag_phishing_versicherung' },
		ikeaCreditCard_smartphone: { event: 'ikea_kreditkarte_antrag_handy_versicherung' },
		backToSelection_IKEA_Kreditkarte: { event: 'ikea_kreditkarte_btn_zurueck_uebersicht' },

		// Kash Borgen Ratenkredit
		kashBorgen_unemployment: { event: 'kash_borgen_antrag_arbeitslosigkeit' },		
		kashBorgen_disability: { event: 'kash_borgen_antrag_arbeitsunfaehigkeit' },		
		kashBorgen_fatality: { event: 'kash_borgen_antrag_todesfall' },	
		backToSelection_Kash_Borgen_Ratenkredit: { event: 'kash_borgen_btn_zurueck_uebersicht' },


		// Kash Reserv Rahmenkredit
		kashReserv_unemployment: { event: 'kash_reserv_antrag_arbeitslosigkeit' },	
		kashReserv_disability: { event: 'kash_reserv_antrag_arbeitsunfaehigkeit' },	
		kashReserv_fatality: { event: 'kash_reserv_antrag_todesfall' },	
		kashReserv_illness: { event: 'kash_reserv_antrag_schwere_krankheit' },	
		kashReserv_aloAssistance: { event: 'kash_reserv_antrag_alo_assistance' },	
		kashReserv_auAssistance: { event: 'kash_reserv_antrag_au_assistance' },	
		backToSelection_Kash_Reserv_Rahmenkredit: { event: 'kash_reserv_btn_zurueck_uebersicht' },


		// Rote MasterCard
		redMastercard_unemployment: { event: 'ikea_mastercard_karte_antrag_arbeitslosigkeit' },
		redMastercard_disability: { event: 'ikea_mastercard_karte_antrag_arbeitsunfaehigkeit' },
		redMastercard_fatality: { event: 'ikea_mastercard_karte_antrag_todesfall' },
		backToSelection_Rote_Mastercard_Karte: { event: 'ikea_mastercard_karte_btn_zurueck_uebersicht' },
	}
});